import middleware from './middleware';
import reducers from './reducers';

export default {
  middleware,
  reducers,
};
